import { Component, OnInit, ViewEncapsulation, Renderer2, Inject, OnDestroy, ViewChild } from '@angular/core';
import { Environment } from '@environments/interface.environment';
import { CUSTOMERENVIRONMENT } from '@app/common/app-tokens';
import { BreakpointObserver } from '@angular/cdk/layout';
import { Constants } from '@app/common/constants';
import { Subscription, Observable } from 'rxjs';
import { RouterLinkActive } from '@angular/router';
import { PlatformLocation } from '@angular/common';

@Component({
  selector: 'app-topnav',
  templateUrl: './topnav.component.html',
  styleUrls: ['./topnav.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class TopnavComponent implements OnInit, OnDestroy {

  subscription = new Subscription();

  constructor(@Inject(CUSTOMERENVIRONMENT) private environment: Environment,
    private renderer: Renderer2,
    private breakpointObserver: BreakpointObserver,
    ) {

    this.subscription.add(
      this.breakpointObserver
        .observe(Constants.BOOTSTRAP_MEDIUM_DEVICE_BREAKPOINT)
        .subscribe(result => {
        }));
  }

  ngOnInit() {

  }

  ngOnDestroy(): void {
    this.subscription && this.subscription.unsubscribe();
  }

}
